import React, { useState } from 'react';
import {
  Box, Typography, Button, Divider, Paper,
  Accordion, AccordionSummary, AccordionDetails,
  Card, CardContent, CardHeader,
  Tabs, Tab, List, ListItem, ListItemIcon, ListItemText, Grid
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk'; // Physical energy
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'; // Mental/Stress
import PsychologyIcon from '@mui/icons-material/Psychology'; // Refocus/Mindset
import WaterDropIcon from '@mui/icons-material/WaterDrop'; // Hydration
import RestaurantIcon from '@mui/icons-material/Restaurant'; // Snack
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'; // Stretching/Jumping Jacks
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // Trophy icon
import StarIcon from '@mui/icons-material/Star'; // Star icon
import { motion } from 'framer-motion'; // For animations
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Checkmark icon
import CelebrationIcon from '@mui/icons-material/Celebration'; // Celebration icon

            {/******
              IVAN NOTE 9/30/2025: COULD ADD ChatComponent.tsx here and have it chat with student about strategies! 
              Could also list out strategesi!!! 
              ********************************************************
              */}


// Props interface for clarity and type safety
interface SectionTransitionProps {
  currentSection: number; // 0-based index of the section just completed
  nextSection: () => void; // Function to call to start the next section/view results
}

// Helper component for consistent advice structure
const AdviceCategory: React.FC<{ title: string; icon: React.ReactNode; children: React.ReactNode }> = ({ title, icon, children }) => (
  <Box sx={{ mb: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      {icon}
      <Typography variant="h6" component="div" sx={{ ml: 1 }}>{title}</Typography>
    </Box>
    <Typography variant="body2" color="text.secondary">{children}</Typography>
  </Box>
);

const SectionTransition: React.FC<SectionTransitionProps> = ({ currentSection, nextSection }) => {
  const sectionNames = [
    "Reading and Writing - Section 1",
    "Reading and Writing - Section 2",
    "Math - Section 1",
    "Math - Section 2"
  ];

  const isLastSectionCompleted = currentSection >= sectionNames.length - 1;
  const isBreakTime = currentSection === 1; // After RW Section 2 (index 1)

  // State for Tab variation
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  /* --- VARIATION 1: Simple Emoji Text ---
  const Title1 = () => (
    <Typography variant="h4" sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      🎉 You Finished {sectionNames[currentSection]}! 🎉
    </Typography>
  );
  
  const Title2 = () => (
    <Box sx={{ mb: 1, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1, rotate: [0, 10, -10, 0] }}
          transition={{ duration: 0.5 }}
        >
          <EmojiEventsIcon color="primary" fontSize="large" />
        </motion.div>
        <Typography variant="h4">
          You Finished {sectionNames[currentSection]}!
        </Typography>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1, rotate: [0, -10, 10, 0] }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <CelebrationIcon color="secondary" fontSize="large" />
        </motion.div>
      </Box>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 1 }}>
          Great job staying focused! 👏
        </Typography>
      </motion.div>
    </Box>
  );
  
  const Title3 = () => (
    <Box sx={{ mb: 2, position: 'relative' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={`top-${i}`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
          >
            <StarIcon 
              sx={{ 
                color: i % 2 === 0 ? 'primary.main' : 'secondary.main',
                mx: 0.5,
                fontSize: i === 2 ? 30 : 24 // Middle star slightly larger
              }} 
            />
          </motion.div>
        ))}
      </Box>
      
      <Typography variant="h4" align="center">
        You Finished {sectionNames[currentSection]}!
      </Typography>
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={`bottom-${i}`}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.5 + i * 0.2 }}
          >
            <CheckCircleIcon 
              sx={{ 
                color: 'success.main',
                mx: 1,
                fontSize: 28
              }} 
            />
          </motion.div>
        ))}
      </Box>
    </Box>
  );*/
  
  
  const Title4 = () => (
    <Box 
      sx={{ 
        mb: 3, 
        py: 2,
        px: 3,
        borderRadius: 2,
        background: 'linear-gradient(90deg, rgba(255,243,224,1) 0%, rgba(255,236,179,1) 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 0.5 }}>
        {/*<Typography variant="body1" sx={{ letterSpacing: 1 }}>
          ✨ 🏆 🎯 ✨
        </Typography>*/}
      </Box>
      <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
      🎉 You Finished {sectionNames[currentSection]}! 🎉
      </Typography>
      {/*<Typography variant="subtitle1" align="center" sx={{ mt: 0.5, color: 'text.secondary' }}>
        {currentSection === 0 ? "You're off to a great start!" : 
         currentSection === 1 ? "Halfway there! You're doing amazing!" :
         "Just one more section to go!"}
      </Typography>*/}
    </Box>
  );
  

  const NextSectionInfo = () => (
    <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
      Next: {sectionNames[currentSection + 1]}
    </Typography>
  );

  const BreakMessage = () => (
    isBreakTime ? (
      <Typography variant="body1" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
        You're halfway through! On the real test, you get a 10-minute break now. Be proud of yourself for your focus and hard work! 
      </Typography>
    ) : (
      <Typography variant="body1" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
        Keep up the good work! You're building a powerful life skill in managing your attention and energy.
      </Typography>
    )
  );

  const ReadyPrompt = () => (
    <Typography variant="body1" sx={{ mt: 4, mb: 2 }}>
      Resting is a skill high performing students develop - and you deserve it. When you're ready, click below to continue.
    </Typography>
  );

  const ContinueButton = () => (
    <Button variant="contained" color="primary" size="large" onClick={nextSection}>
      Begin {sectionNames[currentSection + 1]}
    </Button>
  );

  const FinishTestContent = () => (
     <Box sx={{ p: 4, textAlign: 'center', mt: 10, maxWidth: '600px', mx: 'auto' }}>
        <Typography variant="h4" sx={{ mb: 3 }}>
            Great Job!
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
            Congratulations! You've completed the full practice test.
        </Typography>
        <Button variant="contained" color="primary" size="large" onClick={nextSection}>
            Finish Test & View Results
        </Button>
     </Box>
  );

  // --- RENDER LOGIC ---
  if (isLastSectionCompleted) {
    return <FinishTestContent />;
  }

  // --- ADVICE CONTENT ---
  const adviceContent = {
    tired: (
        <>
        Feeling sluggish or losing focus? Get your body moving!
        <ul>
            <li>Do 15-20 jumping jacks.</li>
            <li>Take a quick walk around the room, hallway, house, or outdoors.</li>{/*Moving, being around nature, and getting fresh air can clear your mind.*/}
            <li>Do some stretches.</li>{/*(reach high and hold your wrists, stretch your legs, touch toes)*/}
            <li>Splash cool water on your face.</li>
        </ul>
        </>
    ),
    stressed: (
        <>
        Feeling anxious or mentally drained? Calm your mind and body.
        <ul>
            <li>Do 3 Physiological Sighs: Do a deep inhale followed by 1-2 sharp inhales through your nose, then exhale slowly.</li>
            <li>Try Box Breathing: Inhale (4s), Hold (4s), Exhale (4s), Hold (4s). Repeat 5 times.</li>
            {/*<li>Get a glass of water - dehydration impacts focus.</li>*/}
            <li>Grab a quick, healthy snack (nuts, fruit) and water.</li>{/*Your brain needs glucose, so carbohydrates and natural sugars are great. Dehydration impacts focus.*/}
            {/*<li>Briefly step away and look out a window. Focus for 10-20 seconds on something in your view and appreciate it.</li>*/}
        </ul>
        </>
    ),
    refocus: (
        <>
        Need a quick mental reset? Shift your perspective.
        <ul>
            <li>Close your eyes for 30 seconds and take slow breaths.</li>
            <li>Praise yourself for one thing you did well in the last section - well done!</li>
            <li>Pick a strategy to focus on for the next section (e.g., "Point to evidence", "Read the full answer choices," "Identify key phrases making answers wrong.").</li> {/*Argue why choices are wrong instead of justifying why they're right*/}
            {/*<li>Remind yourself: This is practice to help you improve.</li>*/}
            {/******IVAN NOTE 9/30/2025: COULD ADD ChatComponent.tsx here and have it chat with student about strategies! Could also list out strategesi!!! */}
        </ul>
        </>
    )
  };


  return (
    <Box sx={{ p: 3, mt: 10, maxWidth: '1400px', mx: 'auto' }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
      
      
      <Title4 />
        {/*<NextSectionInfo />*/}
        
        {/*<BreakMessage />*/}

        <Divider sx={{ my: 3 }} />

        
        <Typography variant="h5" sx={{ mb: 2 }}>Pick One Strategy to Rest Your Mind Before the Next Section</Typography>{/*Your Break, Your Choice: */}
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            textAlign: 'left'
          }}
        >
          <Box sx={{ flex: 1 }}>
            <AdviceCategory title="Boost Your Energy" icon={<DirectionsWalkIcon color="action" />}>
              {adviceContent.tired}
            </AdviceCategory>
          </Box>
          <Box sx={{ flex: 1 }}>
            <AdviceCategory title="Relax and Recharge" icon={<SelfImprovementIcon color="action" />}>
              {adviceContent.stressed}
            </AdviceCategory>
          </Box>
          <Box sx={{ flex: 1 }}>
            <AdviceCategory title="Focus Your Mind" icon={<PsychologyIcon color="action" />}>
              {adviceContent.refocus}
            </AdviceCategory>
          </Box>
        </Box>
        
        <ReadyPrompt />
        {/*<BreakMessage />*/}
        <ContinueButton />
      </Paper>
    </Box>
  );
};

export default SectionTransition;


/* Previous Version before 12:43 pm on 4/16/2025:
Props interface for clarity and type safety
interface SectionTransitionProps {
  currentSection: number; // 0-based index of the section just completed
  nextSection: () => void; // Function to call to start the next section/view results
}

const SectionTransition: React.FC<SectionTransitionProps> = ({ currentSection, nextSection }) => {
  const sectionNames = [
    "Reading and Writing - Section 1",
    "Reading and Writing - Section 2",
    "Math - Section 1",
    "Math - Section 2"
  ];

  // Determine if it's the last section (index 3 is the last of 4 sections)
  const isLastSectionCompleted = currentSection >= sectionNames.length - 1;

  return (
    <Box sx={{ p: 4, textAlign: 'center', mt: 10, maxWidth: '600px', mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        {/* Display 1-based section number }
        You Finished {sectionNames[currentSection]}!
      </Typography>

      {/* Conditional rendering based on whether the last section was just completed 
       *****4/16/2025: FUTURE IDEA: Add a more engaging or celebratory page here with a nice picture or rewarding animation!
      }
      {!isLastSectionCompleted ? (
        <>
          <Typography variant="h6" sx={{ mb: 4 }}>
            {/* Display the name of the *next* section }
            Next: {sectionNames[currentSection + 1]}
          </Typography>
          {/* Show 10-minute break message only between RW and Math }
          {currentSection === 1 ? ( // After RW Section 2 (index 1) is complete
            <>
              <Typography variant="body1" sx={{ mb: 4, fontWeight: 'bold' }}>
                On the real test, you'll have a 10-minute break now before the Math sections. Be proud of yourself for your work! 
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Even if you don't normally do these, take 5 minutes and try going for a short walk, doing stretches or jumping jacks, or deep breaths to the count of 4 in and 4 out.
              </Typography>
             </>
          ) : (
            <>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Keep up the good work! You're building a powerful life skill in managing your attention and energy, so do what you need to do to stay alert and relaxed.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Take a short break if needed - we recommend going for a short walk, doing stretches or jumping jacks, or deep breaths to the count of 4 in and 4 out.
              </Typography>
            </>
          )}
          <Typography variant="body1" sx={{ mb: 4 }}>
            When you're ready, click the button below to continue.
          </Typography>
          <Button variant="contained" color="primary" size="large" onClick={nextSection}>
            Begin {sectionNames[currentSection + 1]}
          </Button>
        </>
      ) : (
        <>
          <Typography variant="h6" sx={{ mb: 4 }}>
            Congratulations! You've completed the full practice test.
          </Typography>
          {/* The onClick should trigger the final steps, which handleNextSection does
              when called after the last section (it calls handleFinishTest) }
          <Button variant="contained" color="primary" size="large" onClick={nextSection}>
            Finish Test & View Results
          </Button>
        </>
      )}
    </Box>
  );
};

export default SectionTransition; // Ensure default export
*/